import { AgentFilesPreview } from '@/components/projects'
import { useAgentDetailContext } from '@/hooks'

export function AgentFilesPage() {
  const { projectId, agent, internalName, description, parsedConfig, canReadMemory } = useAgentDetailContext()

  return (
    <div data-testid="agent-files-section">
      <AgentFilesPreview
        projectId={projectId}
        agent={agent}
        agentName={internalName}
        description={description}
        config={parsedConfig}
        canReadMemory={canReadMemory}
      />
    </div>
  )
}
